import { Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, ListItemText, MenuItem, Select, Switch, TextField } from "@material-ui/core";
import React, { useState } from "react";
import { FieldsLengthConstants, InforDisplyaDuration, ResponseObjectType, InstructionKeysForSCF } from "../../../constants/AppConstants";
import translation from "../../../i18n/i18.json";
import { Department } from "../../../models/Department";
import { FormError } from "../../../models/FormValidation/FormError";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { IndividualPaymentRequestData, VendorIndividualPaymentSubmitData } from "../../../models/VendorRequestChange/VendorRequestChangeData";
import useStyles from "./VendorPopUp.css";
import { PaymentMethod } from "../../../models/PaymentMethod";
import { useDispatch, useSelector } from "react-redux";
import { VendorMasterData } from "../../../services/VendorMasterData";
import AllActions from "../../../actions";
import { VendorBankDetail, VendorDetailState } from "../../../reducers/vendor/VendorDetailReducer";
import { RootState } from "../../../reducers";
import { FormValidateData } from "../../../models/FormValidation/FormValidateData";
import { FormUtil } from "../../../utils/FormUtil";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import { VendorIndividualPaymentService } from "../../../services/VendorIndividualPaymentService";
import { VendorAmendService } from "../../../services/VendorAmendService";

import { Util } from "../../../utils/Util";
import { ToggleButtonGroup, ToggleButton, Autocomplete } from "@material-ui/lab";
import { InstructionKey } from "../../../models/InstructionKey";
import { BankDetails } from "../../../models/BankDetails";
import { AccCurency, CurrencyHouseBank } from "../../../models/AccCurency";

interface IndividualPaymentDialogProps {
    handleClose: any;
    handleCancel: any;
    onUpdateConfirm: any;
    open: boolean;
    title: string;
    departmentList: Array<Department>;
    paymentMethods: Array<PaymentMethod>;
    countryCode?: string;
    companyCode: string;
    isEditMode: boolean;
    requestId: number | null;
    vendorId: number;
    vendorNo: string;
    individualPaymentData: IndividualPaymentRequestData;
    instructionkeys: InstructionKey[];
    currencyHouseBanks: CurrencyHouseBank[];
}

let initialState: IndividualPaymentRequestData = {
    departmentId: 0,
    isEditMode: false,
    vendorId: 0,
    vendorNo: "",
    coCode: "",
    poCode: [],
    paymentMethodCode: [],
    comment: "",
    bankAccWithName: "",
    isIndividualPayment: false,
    bankAccWithSwiftAddress: "",
    estSalesTurnover: 0,
    goodsDesc: "",
    hsCodes: "",
    noOfInvoices: 0,
    isCurrencyUSD: false,
    houseBank: "",
    instructionKey: "",
    currencyId: ""
};

const IndividualPaymentDialog = (props: IndividualPaymentDialogProps) => {
    const { open, handleClose, handleCancel, title, departmentList, paymentMethods, countryCode, companyCode,
        requestId, vendorId, isEditMode, vendorNo, onUpdateConfirm, instructionkeys, currencyHouseBanks } = props;
    //if edit populate data
    if (props.individualPaymentData) {
        let instructionCodeList = instructionkeys.filter(function (item: InstructionKey) {
            return item.name.split(' ')[1] === 'H' || item.name.split(' ')[1] === 'T';
        });
        let instructiondata = instructionCodeList.find(function (item: InstructionKey) {
            return item.code.trim() === (props.individualPaymentData.isIndividualPayment ? 
            InstructionKeysForSCF.OptInVendor : InstructionKeysForSCF.OptOutVendor);
        });

        initialState.departmentId = props.individualPaymentData.departmentId;
        initialState.isEditMode = props.individualPaymentData.isEditMode;
        initialState.vendorId = props.individualPaymentData.vendorId;
        initialState.vendorNo = props.individualPaymentData.vendorNo;
        initialState.coCode = props.individualPaymentData.coCode;
        initialState.poCode = props.individualPaymentData.poCode;
        initialState.paymentMethodCode = props.individualPaymentData.paymentMethodCode;
        initialState.comment = props.individualPaymentData.comment;
        initialState.bankAccWithName = props.individualPaymentData.bankAccWithName;
        initialState.isIndividualPayment = props.individualPaymentData.isIndividualPayment;
        initialState.bankAccWithSwiftAddress = props.individualPaymentData.bankAccWithSwiftAddress;
        initialState.estSalesTurnover = props.individualPaymentData.estSalesTurnover;
        initialState.goodsDesc = props.individualPaymentData.goodsDesc;
        initialState.hsCodes = props.individualPaymentData.hsCodes;
        initialState.noOfInvoices = props.individualPaymentData.noOfInvoices;
        initialState.currencyId = props.individualPaymentData.currencyId;
        initialState.houseBank = props.individualPaymentData.houseBank;
        initialState.instructionKey = instructiondata ? instructiondata.name : "";
    }

    const classes = useStyles();
    const dispatch = useDispatch()
    const [formErrors, setFormErrors] = useState<FormError[]>([]);
    const [filteredPaymentMethod, setFilteredPaymentMethod] = useState(Array<PaymentMethod>());
    const [vendorRequestChange, setVendorRequestChange] = useState<IndividualPaymentRequestData>(initialState);
    const vendorDetail: VendorDetailState = useSelector<RootState, VendorDetailState>((state) => state.vendorDetails);

    const [selectedHouseBanks, setSelectedHouseBanks] = useState(
        Array<CurrencyHouseBank>()
      );

    React.useEffect(() => {
        if (open) {
            setFormErrors([])
        }
    }, [open])

    React.useEffect(() => {
        const filteredPaymentMethods = Util.excludeIsIndividualPaymentMethod(props.paymentMethods);
        setFilteredPaymentMethod(filteredPaymentMethods)

    }, [vendorRequestChange.isIndividualPayment])

    const prepareForRequest = () => {
        dispatch(AllActions.backDropActions.openBackDrop());
    };

    const completeRequest = (
        success: boolean,
        message?: string,
        duration?: number
    ) => {
        dispatch(AllActions.backDropActions.closeBackDrop());
        if (message) {
            let messageDuration = duration ? duration : InforDisplyaDuration.common;
            if (success) {
                dispatch(
                    AllActions.infoActions.openInforSuccess(message, messageDuration!)
                );
            } else {
                dispatch(
                    AllActions.infoActions.openInforError(message, messageDuration!)
                );
            }
        }
    };

    const handleChange = (input: string, propVal?: any) => (e: any) => {
        const numberMax = 9999999999
        const numberMin = 0
        switch (input) {
            case 'isIndividualPayment':
                let instructionCodeList2 = instructionkeys.filter(function (item: InstructionKey) {
                    return item.name.split(' ')[1] === 'H' || item.name.split(' ')[1] === 'T';
                });
                let instructiondata2 = instructionCodeList2.find(function (item: InstructionKey) {
                    return item.code.trim() === (e.target.checked ? 
                    InstructionKeysForSCF.OptInVendor : InstructionKeysForSCF.OptOutVendor);
                });
                setVendorRequestChange({
                    ...vendorRequestChange!,
                    isIndividualPayment: e.target.checked,
                    paymentMethodCode: e.target.checked ? ["H"] : ["T"],
                    instructionKey: instructiondata2 ? (instructiondata2.name) : "",
                    houseBank: !e.target.checked ? "" : vendorRequestChange.houseBank,
                    currencyId: !e.target.checked ? "" : vendorRequestChange.currencyId
                });
                break
            case 'estSalesTurnover':
            case 'noOfInvoices':
                let value = e.target.value;
                if (value > numberMax) { value = numberMax }
                if (value < numberMin) { value = numberMin }
                setVendorRequestChange({
                    ...vendorRequestChange!,
                    [input]: value
                });
                break
            case 'currencyId':
                let curr = e.target.value;
                let houseBanksList = currencyHouseBanks.filter((element) => {
                            return element.currencyCode === curr;
                });
                setSelectedHouseBanks(houseBanksList);
                if(houseBanksList.length === 1){
                setVendorRequestChange({
                    ...vendorRequestChange!,
                    houseBank: houseBanksList[0].houseBank,
                    currencyId: curr
                });
                }
                else{
                    setVendorRequestChange({
                        ...vendorRequestChange!,
                        currencyId: curr
                    });
                }
                break
            default:
                setVendorRequestChange({
                    ...vendorRequestChange!,
                    [input]: e.target.value,
                });
        }

    }

    const getErrorState = (input: string) => {
        // console.log("getErrorState");
        var errIndex = formErrors.findIndex(function (row) {
            return row.fieldName === input && row.errorMsg;
        });
        return errIndex !== -1 ? true : false;
    };

    const handleDelete = (e: React.MouseEvent, value: string, input: string) => {
        e.preventDefault();
        setVendorRequestChange({
            ...vendorRequestChange!,
            "paymentMethodCode": vendorRequestChange.paymentMethodCode.filter(
                (code: string) => {
                    return code !== value;
                }
            ),
        });
    };

    const handleConfirm = (e: any) => {
        if (validateData()) {
            if (!isEditMode && vendorRequestChange.isIndividualPayment === vendorDetail.isIndividualPayement) {
                dispatch(
                    AllActions.infoActions.openInforWarn(translation.individualPayPopup_pay_option_unchanged_warning, InforDisplyaDuration.approvalStatus)
                );
                return
            }
            prepareForRequest();
            // get instruction code
            const _data: VendorIndividualPaymentSubmitData = {
                vendorId: vendorRequestChange.vendorId,
                requestId: isEditMode ? props.requestId : null,
                coCode: companyCode,
                poCode: [],
                departmentId: vendorRequestChange.departmentId,
                comment: vendorRequestChange.comment,
                descOfGoods: vendorRequestChange.goodsDesc,
                estimatedSalesTurnover: vendorRequestChange.estSalesTurnover,
                isIndividualPayement: vendorRequestChange.isIndividualPayment,
                noOfInvoicesPerMonth: vendorRequestChange.noOfInvoices,
                offShoreSupplierHSCode: vendorRequestChange.hsCodes,
                paymentMethodCode: vendorRequestChange.paymentMethodCode,
                supplierCBankAccountSWIFT: vendorRequestChange.bankAccWithSwiftAddress,
                supplierCBankName: vendorRequestChange.bankAccWithName,
                vendorNo: vendorNo,
                instructionKey: vendorRequestChange.isIndividualPayment ? InstructionKeysForSCF.OptInVendor
                    : InstructionKeysForSCF.OptOutVendor,
                houseBank: vendorRequestChange.houseBank
            }
            VendorIndividualPaymentService.submitVendorIndividualPayment(
                _data,
                (vendorIndividualPaymentData: any) => {
                    if (
                        vendorIndividualPaymentData &&
                        vendorIndividualPaymentData.resposeObjectType === ResponseObjectType.Error
                    ) {
                        compeleteRequest(false, vendorIndividualPaymentData.message);
                    } else {
                        compeleteRequest(
                            true,
                            `${vendorIndividualPaymentData.result} ${translation.vendorchangepopup_extend_sucess}`,
                            InforDisplyaDuration.approvalStatus
                        );
                        onUpdateConfirm();
                    }
                },
                (error: Error) => {
                    console.log(error);
                    compeleteRequest(false, translation.vendorchangepopup_extend_error_err);
                }
            )
        }
    }

    const validateData = () => {
        //setFormErrors([]);
        setFormErrors([]);
        //let valid = true;
        let validateFieldsData: Array<FormFieldMeta> = [
            {
                fieldName: "departmentId",
                isRequired: true,
                reuiredMsg: "Department is required",
            },
            {
                fieldName: "paymentMethodCode",
                isRequired: true,
                reuiredMsg: "PaymentMethodCode is required",
                isList: true,
            },
            {
                fieldName: "estSalesTurnover",
                isRequired: vendorRequestChange.isIndividualPayment,
                reuiredMsg: "Estimated Sales Turnover with Buyer this year is required"
            },
            {
                fieldName: "noOfInvoices",
                isRequired: vendorRequestChange.isIndividualPayment,
                reuiredMsg: "No of Invoices per Months is required"
            },
            {
                fieldName: "bankAccWithName",
                isRequired: vendorRequestChange.isIndividualPayment,
                reuiredMsg: "Supplier Bank account with/ Corresponding Bank Name is required"
            },
            {
                fieldName: "bankAccWithSwiftAddress",
                isRequired: vendorRequestChange.isIndividualPayment,
                reuiredMsg: "Supplier Bank account with/ Corresponding Bank SWIFT address is required"
            },
            {
                fieldName: "goodsDesc",
                isRequired: vendorRequestChange.isIndividualPayment,
                reuiredMsg: "Description of Goods  is required"
            },
            {
                fieldName: "hsCodes",
                isRequired: vendorRequestChange.isIndividualPayment,
                reuiredMsg: "HS Codes specific to the Goods/ service is required"
            },
            {
                fieldName: "currencyId",
                isRequired: vendorRequestChange.isIndividualPayment,
                reuiredMsg: "Currency is required"
            },
            {
                fieldName: "houseBank",
                isRequired: vendorRequestChange.isIndividualPayment,
                reuiredMsg: "House Bank is required"
            }
        ];

        let formValidateData: FormValidateData = FormUtil.validateFields(
            validateFieldsData,
            vendorRequestChange
        );
        setFormErrors(formValidateData.errorsList);
        return formValidateData.isValid;
    };

    const compeleteRequest = (
        success: boolean,
        message?: string,
        duration?: number
    ) => {
        dispatch(AllActions.backDropActions.closeBackDrop());
        if (message) {
            let messageduration = duration ? duration : InforDisplyaDuration.common;
            if (success) {
                dispatch(
                    AllActions.infoActions.openInforSuccess(message, messageduration!)
                );
            } else {
                dispatch(
                    AllActions.infoActions.openInforError(message, messageduration!)
                );
            }
        }
    };


    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className={classes.popUpVendorSearch}
            >
                <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <div>
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                            <span className={classes.createLbl}>
                                {translation.individualPayPopup_department_lbl}
                            </span>
                            <div className={classes.inputWrapper_Req}>
                                <Select
                                    variant="outlined"
                                    value={vendorRequestChange.departmentId || ""}
                                    onChange={handleChange("departmentId")}
                                    error={getErrorState("departmentId")}
                                >
                                    {departmentList.map((obj, index) => (
                                        <MenuItem key={obj.id} value={obj.id}>
                                            {obj.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                            <span className={classes.createLbl}>
                                {translation.individualPayPopup_comment_lbl}
                            </span>
                            <div className={classes.inputWrapper}>
                                <TextField
                                    variant="outlined"
                                    value={vendorRequestChange.comment || ""}
                                    onChange={handleChange("comment")}
                                    error={getErrorState("comment")}
                                    inputProps={{
                                        maxLength: FieldsLengthConstants.RequestComments,
                                    }}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                            <span className={classes.createLbl}>
                                {translation.individualPayPopup_individual_pay_lbl}
                            </span>
                            <div className={classes.inputWrapper_Req}>
                                <Switch
                                    disabled={isEditMode}
                                    checked={vendorRequestChange.isIndividualPayment}
                                    onChange={handleChange("isIndividualPayment")}
                                ></Switch>
                            </div>

                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                            <span className={classes.createLbl}>
                                {translation.individualPayPopup_payment_lbl}
                            </span>
                            {!vendorRequestChange.isIndividualPayment &&
                            <span style={{ fontSize: "10px" }}>
                                ({translation.individualPayPopup_payment_Notify_lbl})
                            </span>
                            }
                            <div
                                className={classes.inputWrapper_Req}
                            >
                                <Select
                                    variant="outlined"
                                    multiple
                                    value={vendorRequestChange.paymentMethodCode || []}
                                    onChange={handleChange("paymentMethodCode")}
                                    error={getErrorState("paymentMethodCode")}
                                    disabled={vendorRequestChange.isIndividualPayment || !vendorRequestChange.isIndividualPayment}
                                    renderValue={(selected) => (
                                        <div>
                                            {(selected as string[]).map((value) => (
                                                <Chip
                                                    key={value}
                                                    label={value}
                                                    clickable
                                                    deleteIcon={
                                                        <CancelIcon
                                                            onMouseDown={(event) => event.stopPropagation()}
                                                        />
                                                    }
                                                    onDelete={(e) => handleDelete(e, value, "paymentMethodCode")}
                                                />
                                            ))}
                                        </div>
                                    )}
                                >
                                    {filteredPaymentMethod.map((obj: PaymentMethod, index: number) => (
                                        <MenuItem key={obj.code} value={obj.code}>
                                            <Checkbox
                                                checked={vendorRequestChange.paymentMethodCode.includes(obj.code)}
                                            />
                                            <ListItemText primary={obj.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                        </Grid>
                        {vendorRequestChange.isIndividualPayment &&
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                            <span className={classes.createLbl}>
                                {translation.individualPayPopup_payement_currency_lbl}
                            </span>
                            <div  className={classes.inputWrapper_Req}>
                            <Select
                                disabled={!vendorRequestChange.isIndividualPayment}
                                variant="outlined"
                                value={vendorRequestChange.currencyId || 0}
                                onChange={handleChange("currencyId")}
                                error={getErrorState("currencyId")}
                            >
                                {currencyHouseBanks.map((obj, index) => (
                                <MenuItem key={index} value={obj.currencyCode}>
                                    {obj.currencyCode}
                                </MenuItem>
                                ))}
                            </Select>
                            </div>
                        </Grid>
                        } 
                        {vendorRequestChange.isIndividualPayment &&
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                        <span className={classes.createLbl}>
                                {translation.vendor_detail_bankdetails_housebank_lbl}
                            </span>
                            <div  className={classes.inputWrapper_Req} >
                            <Select
                                disabled={!vendorRequestChange.isIndividualPayment}
                                variant="outlined"
                                value={vendorRequestChange.houseBank || ""}
                                onChange={handleChange("houseBank")}
                                error={getErrorState("houseBank")}
                            >
                                {selectedHouseBanks.map((obj, index) => (
                                <MenuItem key={index} value={obj.houseBank}>
                                    {obj.houseBank}
                                </MenuItem>
                                ))}
                            </Select>
                            </div>
                        </Grid>
                        }
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                            <span className={classes.createLbl}>
                                {translation.individualPayPopup_instruction_key_lbl}
                            </span>
                            {!vendorRequestChange.isIndividualPayment &&
                            <span style={{ fontSize: "10px" }}>
                                ({"Please change the instruction key through an amend request If required"})
                            </span>
                            }
                            <div className={classes.inputWrapper_Req}>
                                <TextField
                                    variant="outlined"
                                    value={vendorRequestChange.instructionKey}
                                    type="string"
                                />
                            </div>
                        </Grid>
                        {vendorRequestChange.isIndividualPayment && (
                            <>
                                <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                                    <span className={classes.createLbl}>
                                        {translation.individualPayPopup_est_sales_turnover_lbl}
                                    </span>
                                    <div className={classes.inputWrapper_Req}>
                                        <TextField
                                            variant="outlined"
                                            value={vendorRequestChange.estSalesTurnover || ""}
                                            onChange={handleChange("estSalesTurnover")}
                                            error={getErrorState("estSalesTurnover")}
                                            type="number"
                                            inputProps={{
                                                maxLength: FieldsLengthConstants.IndividualPayEstSalesTurnover,
                                                max: 9999999999,
                                                min: 0
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                                    <span className={classes.createLbl}>
                                        {translation.individualPayPopup_no_of_invoice_lbl}
                                    </span>
                                    <div className={classes.inputWrapper_Req}>
                                        <TextField
                                            variant="outlined"
                                            value={vendorRequestChange.noOfInvoices || ""}
                                            onChange={handleChange("noOfInvoices")}
                                            error={getErrorState("noOfInvoices")}
                                            type="number"
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: FieldsLengthConstants.IndividualPayNoOfInvoices,
                                                    max: 9999999999, min: 0
                                                }
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                                    <span className={classes.createLbl}>
                                        {translation.individualPayPopup_supplier_bank_acc_name_lbl}
                                    </span>
                                    <div className={classes.inputWrapper_Req}>
                                        <TextField
                                            variant="outlined"
                                            value={vendorRequestChange.bankAccWithName || ""}
                                            onChange={handleChange("bankAccWithName")}
                                            error={getErrorState("bankAccWithName")}
                                            inputProps={{ maxLength: FieldsLengthConstants.IndividualPayBankAccWithName }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                                    <span className={classes.createLbl}>
                                        {translation.individualPayPopup_supplier_bank_acc_swift_lbl}
                                    </span>
                                    <div className={classes.inputWrapper_Req}>
                                        <TextField
                                            variant="outlined"
                                            value={vendorRequestChange.bankAccWithSwiftAddress || ""}
                                            onChange={handleChange("bankAccWithSwiftAddress")}
                                            error={getErrorState("bankAccWithSwiftAddress")}
                                            inputProps={{ maxLength: FieldsLengthConstants.IndividualPayBankAccWithSwiftAddress }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                                    <span className={classes.createLbl}>
                                        {translation.individualPayPopup_goods_desc_lbl}
                                    </span>
                                    <div className={classes.inputWrapper_Req}>
                                        <TextField
                                            variant="outlined"
                                            value={vendorRequestChange.goodsDesc || ""}
                                            onChange={handleChange("goodsDesc")}
                                            error={getErrorState("goodsDesc")}
                                            inputProps={{ maxLength: FieldsLengthConstants.IndividualPayGoodsDesc }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "10px 0px 10px", width: "100%", float: "left", }}>
                                    <span className={classes.createLbl}>
                                        {translation.individualPayPopup_supplier_hs_codes_lbl}
                                    </span>
                                    <div className={classes.inputWrapper_Req}>
                                        <TextField
                                            variant="outlined"
                                            value={vendorRequestChange.hsCodes || ""}
                                            onChange={handleChange("hsCodes")}
                                            error={getErrorState("hsCodes")}
                                            inputProps={{ maxLength: FieldsLengthConstants.IndividualPayHsCodes }}
                                        />
                                    </div>
                                </Grid>
                            </>)
                        }
                    </div>
                </DialogContent>
                <div style={{ margin: "25px 0 0 0" }}>
                    <DialogActions>
                        <div style={{ margin: "20px ​10px 15px 0" }}>
                            <div className={classes.greenBtnWrapper}>
                                <Button onClick={handleConfirm} color="primary">
                                    <CheckCircleIcon></CheckCircleIcon>
                                    Submit
                                </Button>
                            </div>
                            {!isEditMode && (
                                <div className={classes.grayBtnWrapper}>
                                    <Button onClick={handleClose} color="primary" autoFocus>
                                        {translation.vendorchangepopup_close_btn}
                                    </Button>
                                </div>)}
                            {isEditMode && (
                                <div className={classes.grayBtnWrapper}>
                                    <Button onClick={handleCancel} color="primary" autoFocus>
                                        {translation.vendorchangepopup_close_btn}
                                    </Button>
                                </div>)}
                        </div>
                    </DialogActions>
                </div>
            </Dialog>
        </div>
    )
}

export default IndividualPaymentDialog